/**
 * Onboarding Context Definition
 * Separated for React Fast Refresh compatibility
 */

import { createContext } from 'react';
import type { OnboardingContextValue } from '@/types/onboarding';

export const OnboardingContext = createContext<OnboardingContextValue | undefined>(undefined);
